import React, { useCallback } from "react";

import { Link, useHistory } from "react-router-dom";

import { HouseholdMember } from "@fartherfinance/frontend/api/Households/types";

import { getClientFullName } from "../utils";
import { unknownBalanceValue } from "@src/constants/unknownBalanceValue";

interface HouseholdMembersLinkProps {
  members?: HouseholdMember[];
}

const HouseholdMembersLink: React.FC<HouseholdMembersLinkProps> = ({
  members,
}) => {
  const history = useHistory();

  // TODO: Remove after react-router-dom upgrade
  const handleClick = useCallback(
    (member: HouseholdMember) => (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      const location = history.location;
      history.push({
        ...location,
        pathname: `/Advisor/Clients/${member.clientId}`,
      });
    },
    [history]
  );

  return (
    <span>
      {members?.length && members.length > 0 ? (
        <>
          {members?.map((member) => (
            <div key={member.clientId}>
              <Link to={`/Advisor/Clients/${member.clientId}`}>
                <div
                  onClick={handleClick(member)}
                  title={`View client ${getClientFullName(member)} (${
                    member.memberType
                  })}`}
                >
                  {`${getClientFullName(member)} (${member.memberType})`}
                </div>
              </Link>
            </div>
          ))}
        </>
      ) : (
        unknownBalanceValue
      )}
    </span>
  );
};

export default HouseholdMembersLink;
